/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_ImageInputs */

const en_source_image = /** @type {(inputs: Source_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshot`)
};

const de_source_image = /** @type {(inputs: Source_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Screenshot`)
};

/**
* | output |
* | --- |
* | "Screenshot" |
*
* @param {Source_ImageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const source_image = /** @type {((inputs?: Source_ImageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_ImageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_source_image(inputs)
	return en_source_image(inputs)
});